export default {
    props: ['crumbs']
};
